<template>
    <div class="container">
        <!-- Nav tabs -->
        <ul class="nav nav-tabs sticky-top breadcrumb p-0 mb-1 nav-justified" role="tablist">
            <li class="nav-item">
                <a class="nav-link text-center px-2" data-toggle="tab" href="#project">案件情報</a>
            </li>
            <li class="nav-item">
                <a class="nav-link active text-center px-2" data-toggle="tab" href="#apply"><i class="fas fa-envelope text-danger"></i>&nbsp;応募者</a>
            </li>
            <li class="nav-item">
                <a class="nav-link text-center px-2" data-toggle="tab" href="#interview"><i class="fas fa-calendar-check text-success"></i>&nbsp;面接者</a>
            </li>
        </ul>
        <div class="tab-content">
            <div id="project" class="container tab-pane fade p-0">
                <!-- 案件情報 -->
                <proj-info></proj-info>
            </div>

            <div id="apply" class="container tab-pane active p-0">
                <!-- 応募者 -->
                <techs-info ref="tech"></techs-info>
            </div>

            <div id="interview" class="container tab-pane fade p-0">
                <!-- 面接者 -->
                <interviews-info></interviews-info>
            </div>
            <!-- 面接情報設定 -->
            <reply-tech :key="rtKey"></reply-tech>

            <!-- メッセージ -->
            <info-msg ref="msg" :lev="lev" :msg="msg" @ok="msgOk"></info-msg>

            <!-- メニュー -->
            <apply-tech-menu ref="applyTechMenu"></apply-tech-menu>

            <!-- 単価設定 -->
            <apply-price-set ref="applyPriceSet"></apply-price-set>

            <!-- 氏名公開設定 -->
            <tech-name-set ref="techNameSet"></tech-name-set>

            <!-- 個人情報 -->
            <private-info ref="privateInfo"></private-info>

            <!-- 面接取消 -->
            <cancel-intv ref="cancelIntv" opt="0"></cancel-intv>

        </div>
    </div>
</template>

<script>
    import ProjInfo from './ProjInfo'
    import TechsInfo from './TechsInfo'
    import ReplyTech from './ReplyTech'
    import InterviewsInfo from './InterviewsInfo'
    import InfoMsg from 'pages/commons/modal/infoMsg/InfoMsg'
    import ApplyTechMenu from './Menu'
    import ApplyPriceSet from './Price'
    import TechNameSet from './TechName'
    import CancelIntv from 'pages/commons/modal/cancelIntvEnter/CancelIntvEnter'
    import PrivateInfo from 'pages/commons/modal/privateInfo/PrivateInfo'
    import {editProjStartDate} from 'pages/commons/form/comFunc'

    import {mapGetters} from 'vuex'

    export default {
        components: {
            ProjInfo,
            TechsInfo,
            ReplyTech,
            InterviewsInfo,
            InfoMsg,
            ApplyTechMenu,
            ApplyPriceSet,
            CancelIntv,
            PrivateInfo,
            TechNameSet
        },
        data () {
            return {
                lev: 0,
                msg: "",
                msgKey: "",
                selectId: "",
                rtKey: true
            }
        },
        watch: {
            getApprovalApplyStatus (status) {
                if (status == '1') {
                    this.$store.dispatch('startProgress')
                }
                if (status == '2') {
                    // 最新のapplyPostを一覧へ反映
                    this.$store.dispatch('reflectList', this.getNewApplyPost.data)
                    this.$store.dispatch('doneProgress')
                }
                if (status == '3') {
                    this.$store.dispatch('doneProgress')
                }

            }
        },
        computed: {
            ...mapGetters(['getApprovalApplyStatus', 'getNewApplyPost'])
        },
        methods: {
            resetReplyTech () {
                this.rtKey = !this.rtKey
            },
            openMsg (lev, msg, key="", id="") {
                this.lev = lev
                this.msg = msg
                this.msgKey = key
                this.selectId = id
                this.$refs.msg.openThis()
            },
            msgOk () {
                if (this.msgKey == 'approval') {
                    this.$store.dispatch('approvalApply', {
                        applyId: this.selectId,
                    })
                }
            },
            openMenu (item ,key="") {
                this.$refs.applyTechMenu.openThis(item, key)
            },
            openPricePub (item) {
                this.$refs.applyPriceSet.openThis(item)
            },
            openNamePub (item) {
                this.$refs.techNameSet.openThis(item)
            },
            openPrivateInfo (userId) {
                this.$refs.privateInfo.openThis(userId)
            },
            cancelIntv (item) {
                this.$refs.cancelIntv.openThis(item)
            },
            editStartDate (val) {
                return editProjStartDate(val)
            },
        }
    }
</script>

<style>

</style>
